"use client";

import useFeatureFlag from "./featureFlag";

/**
 * Single source of truth for the investment-amount-first feature gates.
 *
 * `INVESTMENT_AMOUNT_ALLOCATIONS_CHARTER_HALL` fully supersedes the original
 * `INVESTMENT_AMOUNT_ALLOCATIONS_MVP` flag. Until MVP is deleted we union the
 * two for UI gating, so consumers don't need to know about MVP.
 */
export function useInvestmentAmountFlags() {
	const isNew = useFeatureFlag("INVESTMENT_AMOUNT_ALLOCATIONS_CHARTER_HALL");
	// TODO(APP-22669): remove once INVESTMENT_AMOUNT_ALLOCATIONS_CHARTER_HALL is at 100%
	const isMvp = useFeatureFlag("INVESTMENT_AMOUNT_ALLOCATIONS_MVP");

	return {
		/**
		 * When true, the place-allocation flow submits the dollar amount
		 * (`requestedValue.money`) to the API instead of the derived
		 * `unitCountDecimal`, and the Orders list renders that amount.
		 */
		isInvestmentAmountSubmission: isNew,
		/**
		 * When true, the place-allocation UI hides the unit fields and shows the
		 * dollar amount as the primary field. Stays on for both the MVP and the
		 * new flag.
		 */
		isInvestmentAmountOnlyUI: isNew || isMvp,
	};
}
